module.exports = __webpack_public_path__ + "static/media/Roboto-Bold-700.b8e42971.ttf";